export default [
  {
    path: '/decks/:deckId?/:parentDeckId?',
    name: 'decks#show',
    component: () => import('@views/decks/show'),
    meta: {
      masteryHeader: true,
    },
  },
  {
    path: '/decks/:deckId/:parentDeckId?/topics/:cardId',
    name: 'decks#topic',
    component: () => import('@views/decks/topic'),
    meta: {
      masteryHeader: true,
      footer: true,
    },
  },
  {
    path: '/decks/:deckId/:parentDeckId?/attachment/:cardId',
    name: 'decks#attachment',
    component: () => import('@views/decks/attachment'),
    meta: {
      masteryHeader: true,
      footer: true,
    },
  },
];
